import Log from "@/vuex/models/log/log";
import Meta from "@/vuex/models/meta";

export default class LogsState {
    public logs: Log[] = [];
    public meta!: Meta;
}
